import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabase';
import './StudentDashboard.css';

function ViewPolicies({ studentData }) {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    if (studentData?.school_id) {
      fetchPolicies();
    }
  }, [studentData?.school_id, selectedCategory]);

  const fetchPolicies = async () => {
    try {
      setLoading(true);
      let query = supabase
        .from('school_policies')
        .select('*')
        .eq('school_id', studentData.school_id)
        .eq('is_published', true)
        .order('created_at', { ascending: false });

      if (selectedCategory !== 'all') {
        query = query.eq('policy_category', selectedCategory);
      }

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching policies:', error);
        setPolicies([]);
      } else {
        setPolicies(data || []);
      }
    } catch (error) {
      console.error('Error fetching policies:', error);
      setPolicies([]);
    } finally {
      setLoading(false);
    }
  };

  const categories = ['all', 'Terms & Conditions', 'Privacy Policy, EULA, Terms of Condition', 'General Policy', 'Student Handbook', 'Code of Conduct'];

  if (loading) {
    return (
      <div className="policies-container">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading policies...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="policies-container">
      <div className="policies-header">
        <h2>📘 School Policies & Handbook</h2>
        <p>View published school policies, terms, and handbooks</p>
      </div>

      <div className="policies-filters">
        <label>Filter by Category:</label>
        <select 
          value={selectedCategory} 
          onChange={(e) => setSelectedCategory(e.target.value)}
          className="policy-filter-select"
        >
          {categories.map(cat => (
            <option key={cat} value={cat}>
              {cat === 'all' ? 'All Categories' : cat}
            </option>
          ))}
        </select>
      </div>

      <div className="policies-list">
        {policies.length === 0 ? (
          <div className="no-policies">
            <p>No published policies available at this time.</p>
          </div>
        ) : (
          policies.map(policy => (
            <div key={policy.id} className="policy-card">
              <div className="policy-card-header">
                <div>
                  {policy.policy_category && (
                    <span className="policy-category-badge">{policy.policy_category}</span>
                  )}
                  <h3>{policy.title}</h3>
                </div>
                <span className={`type-badge ${policy.item_type}`}>
                  {policy.item_type.toUpperCase()}
                </span>
              </div>
              
              {policy.description && (
                <p className="policy-description">{policy.description}</p>
              )}

              <div className="policy-content">
                {policy.item_type === 'link' && policy.link_url ? (
                  <div className="policy-link">
                    <a 
                      href={policy.link_url} 
                      target="_blank" 
                      rel="noreferrer"
                      className="policy-link-btn"
                    >
                      🔗 Open Link
                    </a>
                  </div>
                ) : (
                  policy.file_urls && Array.isArray(policy.file_urls) && policy.file_urls.length > 0 && (
                    <div className="policy-files">
                      <h4>Files:</h4>
                      <div className="file-list">
                        {policy.file_urls.map((file, index) => (
                          <a
                            key={index}
                            href={file.url}
                            target="_blank"
                            rel="noreferrer"
                            className="file-download-link"
                          >
                            📄 {file.name}
                            {file.size && <span className="file-size">({(file.size / 1024).toFixed(1)} KB)</span>}
                          </a>
                        ))}
                      </div>
                    </div>
                  )
                )}
              </div>

              <div className="policy-footer">
                <span className="policy-date">
                  Published: {new Date(policy.published_at || policy.created_at).toLocaleDateString()}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default ViewPolicies;
